
export default {
    name: 'RecorderEmbed',
    props: {
        campaignPath: String | null,
        campaign: Object | null,
        campaignForPreview: Object | null,
        state: String | null,
    },
    data() {
        return {
            recorderURL: null,
            viewName: 'recorder',
        };
    },
    mounted() {
        this.setRecorderURL();
    },
    watch: {
        campaignForPreview(newValue, oldValue) {
            if (newValue.newRecorder !== oldValue.newRecorder) {
                this.setRecorderURL();
            }

            this.sendMessageToIframe();
        },
        state() {
            this.sendMessageToIframe();
        },
    },
    computed: {
        isPreview() {
            return !!this.campaignForPreview;
        },
        tabIndex() {
            return this.isPreview ? -1 : 0;
        },
    },
    methods: {
        setRecorderURL() {
            let url;
            if (this.campaignForPreview) {
                url = `https://${this.$config.webEmbedDomain}/survey/?isPreview=true`;
            } else if (this.campaignPath) {
                url = `https://${this.$config.webEmbedDomain}/survey${this.campaignPath}`;
            } else {
                // This is for preview that's shown in the details page ("usable preview")
                url = `https://${this.$config.webEmbedDomain}/survey${this.extractHref(this.campaign.contributionURL)}`;
            }

            this.recorderURL = url;
        },
        extractHref(fullURL) {
            const url = new URL(fullURL);
            return url.pathname;
        },
        onIframeLoad() {
            this.sendMessageToIframe();
        },
        sendMessageToIframe() {
            if (!this.campaignForPreview) {
                return;
            }

            let state = this.state;
            if (this.campaignForPreview.newRecorder) {
                switch (this.state) {
                    case 'details':
                        state = 'details';
                        break;
                    case 'success':
                        state = 'finished';
                        break;
                    case 'nps':
                        state = 'nps';
                        break;
                    case 'csat':
                        state = 'csat';
                        break;
                    case 'video':
                        state = 'video';
                        break;
                    default:
                        state = 'initial';
                        break;
                }
            }

            if (this.$refs.recorderIframe) {
                const message = {
                    campaign: this.campaignForPreview,
                    state: state,
                };

                this.$refs.recorderIframe.contentWindow.postMessage(message, '*');
            } else {
                console.error('WEB: No iframe ref');
            }
        },
    },
};
